/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEmailTemplateDefinitionResponse
 */
export interface GetEmailTemplateDefinitionResponse {
    /**
     * 
     * @type {string}
     * @memberof GetEmailTemplateDefinitionResponse
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailTemplateDefinitionResponse
     */
    key: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetEmailTemplateDefinitionResponse
     */
    fields: { [key: string]: string; };
}

/**
 * Check if a given object implements the GetEmailTemplateDefinitionResponse interface.
 */
export function instanceOfGetEmailTemplateDefinitionResponse(value: object): value is GetEmailTemplateDefinitionResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function GetEmailTemplateDefinitionResponseFromJSON(json: any): GetEmailTemplateDefinitionResponse {
    return GetEmailTemplateDefinitionResponseFromJSONTyped(json, false);
}

export function GetEmailTemplateDefinitionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmailTemplateDefinitionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'key': json['key'],
        'fields': json['fields'],
    };
}

export function GetEmailTemplateDefinitionResponseToJSON(json: any): GetEmailTemplateDefinitionResponse {
    return GetEmailTemplateDefinitionResponseToJSONTyped(json, false);
}

export function GetEmailTemplateDefinitionResponseToJSONTyped(value?: GetEmailTemplateDefinitionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'key': value['key'],
        'fields': value['fields'],
    };
}

